import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledSpan = styled.span`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('20px')};
  font-weight: 600;
`;

export const StyledWrapper = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
